import request from '@/utils/request'
/**
 *
 * 日期管理
 *
 **/

// 查询列表数据
export const getSetmealPage = (params: any) => {
  return request({
    url: '/setmeal/page',
    method: 'get',
    params,
  },)
}



// 修改数据接口
export const editSetmeal = (params: any) => {
  return request({
    url: '/setmeal',
    method: 'put',
    data: { ...params }
  })
}

// 新增数据接口
export const addData = (params: any) => {
  return request({
    url: '/userinfo/date',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: { ...params }
  })
}

// 查询详情接口
export const queryData = () => {
  return request({
    url: `/userinfo/queryData`,
    method: 'get',
  },)
}

// 批量起售禁售
export const setmealStatusByStatus = (params: any) => {
  return request({
    url: `/setmeal/status/${params.status}`,
    method: 'post',
    params: { id: params.ids }
  })
}

//菜品分类数据查询
export const dishCategoryList = (params: any) => {
  return request({
    url: `/category/list`,
    method: 'get',
    params: { ...params }
  })
}
